import styled from 'styled-components'

import { toRem } from 'styles'

type Props = {
	isVisible: boolean
	hasError: boolean
	hasIcon?: boolean
}

export const Placeholder = styled.label<Props>`
	display: block;
	position: absolute;
	pointer-events: none;
	font-size: ${toRem(16)};
	font-weight: normal;
	inset: 16px auto 1px ${({ hasIcon }) => (hasIcon ? 52 : 16)}px;
	opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
	transition: color 0.2s, opacity 0.2s;
	color: ${({ hasError, theme }) => {
		if (hasError) {
			return theme.color.danger
		}
		return theme.color.textMuted
	}};
`
